import {
  AgentFlowProgress,
  dispatch,
  updateAgentDataFromFirebase,
} from '@zonofi/zono-money-store';
import {
  collection,
  getDocs,
  updateDoc,
  doc,
  writeBatch,
  addDoc,
  query,
  limit,
} from 'firebase/firestore';

const IS_PROD_ENV = process.env.NX_APP_ENV === 'PROD';

// Agent JTBD Flow
/** Initializes the agent flow for a user in firebase */
export const initializeAgentFlow = async (userId: string) => {
  try {
    const agentFlowItemsRef = collection(
      globalThis.sellerFirebasedb,
      IS_PROD_ENV ? 'users_prod' : 'users_qa',
      userId,
      'agent_flow'
    );

    const agentFlowItems = [
      { title: 'upload_knowledge', order: 1 },
      { title: 'test_agent', order: 2 },
      { title: 'waba_success', order: 3 },
    ];

    const agentFlowItemsSnapshot = await getDocs(
      query(agentFlowItemsRef, limit(1))
    );

    if (!agentFlowItemsSnapshot.empty) {
      console.log(`Agent flow already initialized for user ${userId}`);
      return []; // Or return existing agent flow if needed
    }

    let agentFlowUpdatedItems = [];
    for (const agentFlowItem of agentFlowItems) {
      const agentFlowItemDoc = await addDoc(agentFlowItemsRef, {
        title: agentFlowItem?.title,
        status: 'pending',
        order: agentFlowItem?.order,
        createdAt: new Date().toISOString(),
      });
      agentFlowUpdatedItems.push(agentFlowItemDoc);
      console.log(
        `Initialized agent flow item ${agentFlowItem} for user ${userId} : `,
        ' docId : ',
        agentFlowItemDoc?.id
      );
    }
    return agentFlowUpdatedItems;
  } catch (error) {
    throw new Error(`Error initializing agent flow for user: ${error}`);
  }
};

/** fetches latest agent flow data from firebase : "users_<env>/<userId>/agent_flow" and returns the data. */
export const getAgentFlowProgress = async (userId: string) => {
  console.log('Getting firebase agent_flow data');

  console.log('userId from firebasecontroller :', userId);

  if (userId) {
    const agentFlowRef = collection(
      globalThis.sellerFirebasedb,
      IS_PROD_ENV ? 'users_prod' : 'users_qa',
      userId,
      'agent_flow'
    );
    console.log('agentFlowRef from firebasecontroller :', agentFlowRef);
    const snapshot = await getDocs(agentFlowRef);

    console.log('snapshot: ', snapshot);
    //@ts-ignore
    const agentFlowDataFromFirebase: AgentFlowProgress[] = snapshot.docs.map(
      (doc) => {
        const data = doc.data();

        return { id: doc.id, ...data };
      }
    );
    dispatch(updateAgentDataFromFirebase(agentFlowDataFromFirebase));
    return agentFlowDataFromFirebase;
  }

  return [];
};

/** Updates the agent flow items's status from pending to completed in users_<env>/<userId>/checklist in firebase.userId>/checklist". If the item's status is already completed, it simply returns.
 * @param {string} itemId - The id of the checklist item to update
 */
export const updateAgentFlowProgress = async (
  userId: string,
  order: number
) => {
  console.log('userId : ', userId, ' order : ', order);
  const agentFlowDataFromFirebase = await getAgentFlowProgress(userId);
  if (
    agentFlowDataFromFirebase?.find((i) => i?.order === order)?.status !==
    'completed'
  ) {
    const itemId = agentFlowDataFromFirebase?.find(
      (i) => i?.order === order
    )?.id;
    console.log(
      'item id from updateAgentFlowProgress: ',
      itemId,
      'item status from updateAgentFlowProgress: ',
      agentFlowDataFromFirebase?.find((i) => i?.order === order)?.status
    );
    if (itemId) {
      const itemRef = doc(
        globalThis.sellerFirebasedb,
        IS_PROD_ENV ? 'users_prod' : 'users_qa',
        userId,
        'agent_flow',
        itemId
      );
      await updateDoc(itemRef, {
        status: 'completed',
        updatedAt: new Date().toISOString(),
      });

      getAgentFlowProgress(userId);
    } else {
      console.error('itemId not found !');
    }
  }
};

/** Resets the agent flow items's status from completed to pending in users_<env>/<userId>/agent_flow in firebase.userId>/agent_flow". */
export const resetAgentFlowProgress = async (userId: string) => {
  const batch = writeBatch(globalThis.sellerFirebasedb);

  const now = new Date().toISOString();

  const agentFlowDataFromFirebase = await getAgentFlowProgress(userId);
  const itemIds = agentFlowDataFromFirebase?.map((i) => i?.id);

  itemIds.forEach((itemId) => {
    const itemRef = doc(
      globalThis.sellerFirebasedb,
      IS_PROD_ENV ? 'users_prod' : 'users_qa',
      userId,
      'agent_flow',
      itemId
    );
    batch.update(itemRef, {
      status: 'pending',
      updatedAt: now,
    });
  });

  await batch.commit();
  getAgentFlowProgress(userId);
};
